import styled from 'styled-components/native'

import { ProximaNova } from '../App/Components'

export const StyledTitle = styled(ProximaNova)`
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
`
